const getScrollContainer = (element: HTMLElement): HTMLElement => {
	for (
		let parent = element.parentElement;
		parent;
		parent = parent.parentElement
	) {
		const { overflowY } = getComputedStyle(parent)
		if (
			/auto|scroll|overlay/.test(overflowY) &&
			parent.scrollHeight > parent.clientHeight
		) {
			return parent
		}
	}
	return (document.scrollingElement ??
		document.documentElement) as HTMLElement
}

// Opening an accordion item collapses the previously open one. When that one
// sits above, the content shrinks and the clicked trigger slides up, past the
// sticky header if the collapsed part is taller than the distance to it.
// Correcting after the animation shows up as a second jump, so instead the
// trigger is stopped at its scroll-margin-top (the sticky header offset) on
// every frame of the animation.
export const keepTopEdgeVisibleDuringCollapse = (
	element: HTMLElement,
	animationDuration: number,
) => {
	const scrollContainer = getScrollContainer(element)
	const containerTop =
		scrollContainer === document.scrollingElement
			? 0
			: scrollContainer.getBoundingClientRect().top
	const minTop =
		containerTop + parseFloat(getComputedStyle(element).scrollMarginTop)
	const endTime = performance.now() + animationDuration * 1.25

	const clamp = () => {
		const overshoot = element.getBoundingClientRect().top - minTop
		if (overshoot < 0) {
			scrollContainer.scrollBy({ top: overshoot, behavior: 'instant' })
		}
		if (performance.now() < endTime) {
			requestAnimationFrame(clamp)
		}
	}

	requestAnimationFrame(clamp)
}
